import { observable } from "mobx"

export type JudgeEnteredArgs = {
  image: boolean
  application_categories: boolean
  job_hunting_interest: boolean
  student_company_selections: boolean
  self_appeals: boolean // 旧 thinking　skill
  experiences: boolean
}

export class JudgeEntered {
  @observable image: boolean
  @observable application_categories: boolean
  @observable job_hunting_interest: boolean
  @observable student_company_selections: boolean
  @observable self_appeals: boolean
  @observable experiences: boolean

  constructor(args: JudgeEnteredArgs) {
    this.image = args.image ?? true
    this.application_categories = args.application_categories ?? true
    this.job_hunting_interest = args.job_hunting_interest ?? true
    this.student_company_selections = args.student_company_selections ?? true
    this.self_appeals = args.self_appeals ?? true
    this.experiences = args.experiences ?? true
  }
}
